import React,{useState,useEffect} from 'react';
import { Zap } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const styles = {
    header: {
        position: 'fixed',
        top: '1rem', // Add some top margin for better visibility
        left: '5%', // Center the header by adjusting left margin
        width: '90%', // Set width to 80% of the screen
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        zIndex: 1000,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 2rem',
        borderRadius: '1.6rem', // Curvy capsule shape
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    logoImage: {
        width: '40px',
        height: '40px',
        objectFit: 'contain',
    },
    logoText: {
        fontSize: '1.5rem',
        // color: '#6A5AE0',
        fontFamily: 'Lexend, sans-serif',
        color: '#3E3E3E',
        fontWeight: 'bold',
        letterSpacing: 1.2,
    },
    xpTracker: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        backgroundColor: '#6A5AE0',
        color: '#fff',
        padding: '0.5rem 1rem',
        borderRadius: '0.5rem',
    },
};

const FixedHeader = ({ xpPoints }) => {
    const [homeLink, setHomeLink] = useState('/');
    const location = useLocation()
    useEffect(() => {
            const searchParams = new URLSearchParams(location.search);
            const utmSource = searchParams.get('utm_source');
            const utmMedium = searchParams.get('utm_medium');
            const utmCampaign = searchParams.get('utm_campaign');
            
            // Create a new URLSearchParams object for the beta link
            const betaParams = new URLSearchParams();
            
            // Add UTM parameters if they exist
            if (utmSource) betaParams.append('utm_source', utmSource);
            if (utmMedium) betaParams.append('utm_medium', utmMedium);
            if (utmCampaign) betaParams.append('utm_campaign', utmCampaign);
            
            // Construct the new beta link with UTM parameters
            const params = betaParams.toString();
            const newBetaLink = params ? `/?${params}` : '/';
            
            setHomeLink(newBetaLink);
        }, [location.search]);
    return (
        <header style={styles.header}>
            <div style={styles.logoContainer}>
                <Link to={homeLink} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <img src="/PrepAiro.png" alt="PrepAiro Logo" style={styles.logoImage} />
                </Link>
                <Link to={homeLink} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <span style={styles.logoText}>PrepAiro</span>
                </Link>
            </div>
            <div style={styles.xpTracker}>
                <Zap className="w-5 h-5" />
                <span>{xpPoints} XP</span>
            </div>
        </header>
    );
};

export default FixedHeader;